import { useState } from "react";
import { Lock, LogIn } from "lucide-react";
import { LogoFull } from "../components/Logo";
import { PasswordInput } from "../components/PasswordInput";
import { login, forgotPassword, formatApiError } from "../lib/adminApi";

const ForgotPassword = () => {
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState("");
    const [msg, setMsg] = useState("");
    const [busy, setBusy] = useState(false);
    const send = async () => {
        setBusy(true);
        try {
            setMsg((await forgotPassword(email)).message);
        } catch (err) {
            setMsg(formatApiError(err));
        } finally {
            setBusy(false);
        }
    };
    if (!open) {
        return (
            <button type="button" onClick={() => setOpen(true)} data-testid="admin-forgot-open" className="mt-5 block w-full text-center text-sm font-semibold text-[#0B1F3A] underline decoration-[#E30613] decoration-2 underline-offset-4">
                Password dimenticata?
            </button>
        );
    }
    return (
        <div className="mt-5 rounded-2xl bg-slate-50 p-4" data-testid="admin-forgot-box">
            <p className="text-sm text-[#4F5D70]">Inserisci l'email dell'account: riceverai un link valido 1 ora per impostare una nuova password.</p>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email@esempio.it" data-testid="admin-forgot-email" className="mt-3 w-full rounded-xl border border-slate-200 px-4 py-3 text-sm text-[#0B1F3A] outline-none focus:border-[#0B1F3A]" />
            <button type="button" onClick={send} disabled={busy || !email} data-testid="admin-forgot-send" className="mt-3 w-full rounded-full bg-[#0B1F3A] px-6 py-3 text-sm font-bold text-white disabled:opacity-50">
                {busy ? "Invio…" : "Inviami il link"}
            </button>
            {msg && <p data-testid="admin-forgot-message" className="mt-3 text-sm font-semibold text-emerald-700">{msg}</p>}
        </div>
    );
};

export const AdminLogin = ({ onLogin }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError("");
        try {
            onLogin(await login(email, password));
        } catch (err) {
            setError(formatApiError(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-[#0B1F3A] px-4">
            <form
                onSubmit={submit}
                data-testid="admin-login-form"
                className="w-full max-w-md rounded-3xl bg-white p-8 shadow-[0_32px_80px_-24px_rgba(0,0,0,0.5)] sm:p-10"
            >
                <LogoFull />
                <div className="mt-8 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#E30613]">
                    <Lock className="h-3.5 w-3.5" /> Area riservata
                </div>
                <h1 className="font-display mt-2 text-2xl font-extrabold text-[#0B1F3A]">
                    Pannello di gestione FTM Group
                </h1>
                <label className="mt-6 block text-xs font-bold uppercase tracking-wider text-[#4F5D70]">
                    Email
                    <input
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        data-testid="admin-login-email"
                        className="mt-1.5 w-full rounded-xl border border-slate-200 px-4 py-3 text-sm font-normal normal-case tracking-normal text-[#0B1F3A] outline-none focus:border-[#0B1F3A]"
                    />
                </label>
                <label className="mt-4 block text-xs font-bold uppercase tracking-wider text-[#4F5D70]">
                    Password
                    <PasswordInput required value={password} onChange={(e) => setPassword(e.target.value)} testId="admin-login-password" autoComplete="current-password" />
                </label>
                {error && <p role="alert" data-testid="admin-login-error" className="mt-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-[#B91C1C]">{error}</p>}
                <button
                    type="submit"
                    disabled={busy}
                    data-testid="admin-login-submit"
                    className="mt-7 flex w-full items-center justify-center gap-2 rounded-full bg-[#E30613] px-6 py-3.5 text-sm font-bold text-white transition-colors hover:bg-[#C20410] disabled:opacity-60"
                >
                    <LogIn className="h-4 w-4" />
                    {busy ? "Accesso in corso…" : "Accedi"}
                </button>
                <ForgotPassword />
            </form>
        </div>
    );
};
